/* ============================================================
   送信に失敗して戻されたときに、理由を画面に出す

   URLに載るのは **決められたコードだけ**（required / attach / mail / speed / send）。
   文言はこのファイルの固定表から選ぶので、
   **利用者の入力が画面に出る経路が無い**＝反射XSSにならない。

   コードを付けているのは mail-form.jp 側（_lib/mailer.php の fsj_fail）。
   ============================================================ */
(function () {
  "use strict";

  var MESSAGES = {
    required: "入力されていない必須項目があります。もう一度ご確認のうえ送信してください。",
    attach:   "添付ファイルを受け取れませんでした。画像は1枚5MBまで・5枚まで、形式は JPEG／PNG／WebP です。",
    mail:     "メールアドレスの形式をご確認ください。",
    speed:    "送信を受け付けられませんでした。お手数ですが、もう一度送信してください。",
    busy:     "続けて送信されたため、受け付けられませんでした。1分ほどおいてから、もう一度送信してください。",
    send:     "送信に失敗しました。お手数ですが、時間をおいてもう一度お試しください。"
  };

  var code = new URLSearchParams(window.location.search).get("error");
  if (!code || !Object.prototype.hasOwnProperty.call(MESSAGES, code)) return;

  /* 🚨 以前は document.querySelector("form") ＝**ページ最初のフォーム**だった。
        いまの静的HTMLはフォームが1つなので当たっているが、
        **Shopifyのヘッダーには検索フォームがあるのが普通**なので、
        移植した途端にエラーが検索窓の横に出て、利用者の目に入らなくなる。
        隠し項目を目印にして、送信するフォーム自身を掴む。 */
  var stamp = document.querySelector('input[name="fsj_ts"]');
  var form  = (stamp && stamp.form) || document.querySelector("form");
  if (!form) return;

  var text = MESSAGES[code];

  /* 🚨 弾かれて戻ると、入力した文字は復元される（*-form-guard.js）が、
     **ファイルだけは復元できない**（ブラウザの仕様上、File は保存できない）。
     何も言わないと、利用者は写真も残っていると思い込んで再送信し、
     今度は添付エラーで弾かれる。**往復が1回増える。**
     選び直しが要ることを、その場で伝える。 */
  var fileNames = [];
  Array.prototype.forEach.call(form.querySelectorAll('input[type="file"]'), function (el) {
    if (!el.name) return;
    var n = el.name.replace(/\[\]$/, "");
    if (fileNames.indexOf(n) === -1) fileNames.push(n);
  });
  if (fileNames.length) {
    text += "（" + fileNames.join("・") + " は選び直してください）";
  }

  var box = document.createElement("p");
  box.className = "fsj-formerror";
  box.setAttribute("role", "alert");
  box.textContent = text;      // textContent。HTMLとして解釈させない
  form.parentNode.insertBefore(box, form);

  /* 画面の途中で戻ってくることがあるので、見える位置まで運ぶ */
  if (box.scrollIntoView) box.scrollIntoView({ block: "center" });
})();
